import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import { TokenHandler } from '@/components/auth/TokenHandler';
import { getCurrentMerchant } from '@/utils/routing';
import { applyMerchantTheme } from '@/styles/theme';

export const Layout: React.FC = () => {
  useEffect(() => {
    // Apply merchant-specific theme on mount
    const merchantId = getCurrentMerchant();
    applyMerchantTheme(merchantId);
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Handle authentication token from URL */}
      <TokenHandler />
      {/* Desktop Sidebar */}
      <div className="hidden md:flex">
        <Navigation variant="desktop" />

        {/* Main Content Area */}
        <main className="flex-1 overflow-auto">
          <div className="max-w-7xl mx-auto p-6">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden">
        {/* Main Content with bottom padding for nav */}
        <main className="pb-20">
          <div className="p-4">
            <Outlet />
          </div>
        </main>

        {/* Mobile Bottom Navigation */}
        <Navigation variant="mobile" />
      </div>
    </div>
  );
};

export default Layout;
